import { CartAddEvent, ThemeEvents } from '@theme/events';

document.addEventListener(ThemeEvents.cartUpdate, async (event) => {
  if (!(event instanceof CartAddEvent) || event.detail?.data?.didError) return;

  try {
    const response = await fetch('/cart.js', {
      headers: {
        Accept: 'application/json',
      },
    });

    if (!response.ok) return;

    const cartJson = await response.json();
    const klaviyoData = {
      total_price: cartJson.total_price / 100,
      $value: cartJson.total_price / 100,
      total_discount: cartJson.total_discount,
      original_total_price: cartJson.original_total_price / 100,
      items: cartJson.items,
    };

    window._learnq = window._learnq || [];
    window._learnq.push(['track', 'Added to Cart', klaviyoData]);
  } catch (error) {
    console.warn('Unable to track Klaviyo Added to Cart event', error);
  }
});
